export const ROLES = [
  "Reserved",
  "Superuser",
  "Minter",
  "Caster",
  "Transferer",
  "Configurer",
  "Maintainer",
  "Creator",
  "Limiter",
  "Burner",
  "Destroyer",
  "Oracle",
];

export const ROLE_DESCRIPTIONS = {
  "Reserved": "Reserved for system use",
  "Superuser": "Can perform any action without restriction",
  "Minter": "Allowed to mint new token instances to addresses",
  "Caster": "Can create role tokens from existing permissions",
  "Transferer": "Can transfer tokens between addresses",
  "Configurer": "Can update token metadata and settings",
  "Maintainer": "Can maintain and update token properties",
  "Creator": "Can create new token types",
  "Limiter": "Can set maximum supply limits on tokens",
  "Burner": "Can burn tokens from any address",
  "Destroyer": "Can permanently destroy token types",
  "Oracle": "Can provide external data to the token contract"
};

export interface RoleOption {
  id: number;
  name: string;
  description: string;
}

export const getRoleOptions = (): RoleOption[] => {
  return ROLES.map((name, index) => ({
    id: index,
    name,
    description: ROLE_DESCRIPTIONS[name as keyof typeof ROLE_DESCRIPTIONS] || ""
  }));
};